import { combineReducers } from "redux";
import manage_withdraw_request from "../features/admin/manage_withdraw_request/Slice";

const ManageWithdrawRequest = combineReducers({
  manage_withdraw_request: manage_withdraw_request,
});

export default ManageWithdrawRequest;
